module.exports = __webpack_public_path__ + "static/media/icon-money-white.6bc795d9.svg";